import { RefreshCw } from '@/components/common/icons';

export function ClientsPortalHeader({
  employeeLabel,
  onRefresh,
  showAddClient,
  onAddClient,
  canSync,
  onSync,
  submitting
}) {
  return (
    <div className="page-card__header">
      <div>
        <p className="page-card__eyebrow">Client Records</p>
        <h1 className="page-card__title">Clients Portal</h1>
      </div>

      <div className="dashboard-controls mobile-header-controls">
        <div className="page-card__status">{employeeLabel}</div>
        {canSync && (
          <button
            type="button"
            className="fms-header-btn"
            onClick={onSync}
            disabled={submitting}
            style={{
              marginRight: '12px',
              padding: '8px 20px',
              borderRadius: '999px',
              background: '#fff',
              color: '#6941C6',
              border: '1.5px solid #6941C6',
              fontWeight: '600',
              cursor: submitting ? 'wait' : 'pointer',
              opacity: submitting ? 0.7 : 1,
              transition: 'all 0.2s ease'
            }}
          >
            {submitting ? 'FETCHING...' : 'FETCH DATA'}
          </button>
        )}
        {showAddClient ? (
          <button type="button" className="attendance-cta attendance-cta--green" onClick={onAddClient}>
            <span aria-hidden="true">+</span>
            Add Client
          </button>
        ) : null}
      </div>
    </div>
  );
}
